import React, { useState } from 'react'

import { Element } from "components/shared/base"
import NavigationItem from "./NavigationItem"
import { 
  PrismicNavigationDataType
} from "types/__generated__/gatsby-graphql"

interface OwnProps {
  navigationLinks: PrismicNavigationDataType["top_navigation"],
}

type NavigationProps = OwnProps

const Navigation: React.FC<NavigationProps> = ({
  navigationLinks
}): React.ReactElement => {

  const [ isMobileNavOpen , setIsMobileNavOpen ] = useState(false)

  return (
    <Element as="nav" ml="auto">
      <Element
        aria-label="Open the navigation menu"
        as="button"
        bg="transparent"
        border="0"
        display={["inline-block", "none"]}
        color="coral"
        cursor="pointer"
        fontSize="text.titleMobile"
        p="0"
        onClick={() => setIsMobileNavOpen(!isMobileNavOpen)}
        transform={[`${isMobileNavOpen ? "rotate(225deg)": ""}`, ""]}
      >
        <span aria-hidden="true">+</span>
      </Element>
      <Element
        as="nav"
        bg={["white", ""]}
        ml="auto"
        mt={["15px", "0"]}
        left="0"
        position={["absolute", "static"]}
        width={["100%", "auto"]}
      >
        <Element as="ul" display={[`${isMobileNavOpen ? "block" : "none"}`, "flex"]} lineHeight="33px">
        {navigationLinks?.map((item) => {
          const linkUrl = item?.link?.slug || "";
          const linkText = item?.link_label || "";
          const linkId = item?.link?.id;

          if(!linkUrl || !linkText) {
            return null
          }

          return (
            <NavigationItem href={linkUrl} key={linkId} text={linkText} />
          )
        })}
        </Element>
      </Element>
    </Element>
  )
}

export default Navigation
